import { defineMessages } from 'react-intl';

export default defineMessages({
  'heading': {
    'id': 'sessions.heading',
    'defaultMessage': 'Sessions',
    'description': 'Sessions page heading and title'
  },
  'intro': {
    'id': 'sessions.intro',
    'defaultMessage': 'A timeline of your latest sessions using Ret\u00FCl technology.',
    'description': 'Sessions page heading intro'
  },
  'empty': {
    'id': 'sessions.empty',
    'defaultMessage': 'You haven’t had any sessions.',
    'description': 'Sessions page empty intro'
  },
  'loading_error': {
    'id': 'sessions.loading_error',
    'defaultMessage': 'We are unable to retrieve your Sessions at this time, please try again later.',
    'description': 'Sessions page loading error intro'
  },
  'empty_cta_label': {
    'id': 'sessions.empty_cta_label',
    'defaultMessage': 'Find Locations',
    'description': 'Sessions page empty button label'
  },
  'loading_error_cta_label': {
    'id': 'sessions.loading_error_cta_label',
    'defaultMessage': 'Try Again',
    'description': 'Sessions page empty loading error button label'
  },
  'session_type_filter_label': {
    'id': 'sessions.session_type_filter_label',
    'defaultMessage': 'Session Type',
    'description': 'Sessions page session type filter label'
  },
  'download_pdf_cta_label': {
    'id': 'sessions.download_pdf_cta_label',
    'defaultMessage': 'Download PDF',
    'description': 'Sessions page download PDF button label'
  },
});



// WEBPACK FOOTER //
// ./src/client/pages/sessions/messages.js